let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lSzlP")).then(() => parcelRequire('guaI6'));